import { SHARE, ABS } from '../constants/variables';

const shareColorScope = [ -80, -70, -50, 0, 50, 100, 200 ];
const absOpensColorScope = {
    30: [ 0, 200, 400, 800, 1000, 1600 ],
    7: [ 0, 100, 200, 500, 700, 1000 ],
};
const absTapsColorScope = {
    30: [ 0, 100, 200, 500, 1000, 1500 ],
    7: [ 0, 50, 150, 300, 500, 700 ],
};

export const getUserTapsColorScope = (days, mode, prefix) => {
    if (mode === SHARE) {
        return shareColorScope;
    }
    if (mode === ABS && prefix === 'taps') {
        return absTapsColorScope[days];
    }
    if (mode === ABS && prefix === 'opens') {
        return absOpensColorScope[days];
    }
    return absOpensColorScope[days];
};
